import { useActionState, useState, useContext, useEffect, useTransition, useOptimistic } from "react";
import axios from "axios";
import { format } from "date-fns";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

// Table関連
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, } from '@mui/material';
// import { TableVirtuoso } from 'react-virtuoso';

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { CircularProgress, Chip, Box, LinearProgress, Switch, Checkbox } from '@mui/material';

import { DataGrid, gridClasses } from '@mui/x-data-grid';

const columns = [
  // { field: 'id' },
  { field: 'uuid' },
  { field: 'name' },
  { field: 'is_active' },
  // { field: 'is_checked' },
  // { field: 'checked_datetime' },
  // { field: 'score', type: 'number', width: 200, valueFormatter: (value) => `${value}` },
];

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32dae6)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const StyledButtonLogLists = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32e647)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const Checklist2 = () => {
  // const { apiUserHost, } = useContext(AppContext);
  const { cookies } = useContext(CookieContext);
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist2/';
  const [loading, setLoading] = useState(true);

  // const [disabled, setDisabled] = useState(true);
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);

  const [refresh, setRefresh] = useState(false);
  const [error, setError] = useState();
  const [checklists, setChecklists] = useState([]);
  const [recordChecklists, setRecordChecklists] = useState([]);
  const [logs, setLogs] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  // const [dataId, setDataId] = useState('-');
  const [uuid, setUuid] = useState();
  const [name, setName] = useState();
  // const [dataName, setDataName] = useState();

  const [circularProgressOpen, setCircularProgressOpen] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertId, setAlertId] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const [editOpen, setEditOpen] = useState(false);
  // const [alertId, setAlertId] = useState('');
  // const [alertTitle, setAlertTitle] = useState('');
  // const [alertMessage, setAlertMessage] = useState('');

  const [recordOpen, setRecordOpen] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [recordTitle, setRecordTitle] = useState('');
  const [recordMessage, setRecordMessage] = useState('');

  const [optimisticData, addOptimisticData] = useOptimistic(
    { id: '', is_checked: '', check_datetime: '' },
    (prevData, newData) => ({ ...prevData, ...newData })
  );

  const weekDay = [
    '<font color="#ff0000">日</font>',
    '<font color="#003f00">月</font>',
    '<font color="#437943">火</font>',
    '<font color="#003f00">水</font>',
    '<font color="#003f00">木</font>',
    '<font color="#003f00">金</font>',
    '<font color="#0000ff">土</font>',
  ]

  const [isPending, startTransition] = useTransition();

  const handleAlertOpen = (id, title, message) => {
    setAlertId(id);
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  }

  const handleAlertClose = () => {
    setAlertOpen(false);
  }

  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const handleEditDialogOpen = () => {
    setEditDialogOpen(true);
  }

  const handleEditDialogClose = (e) => {
    setEditDialogOpen(false);
    e.preventDefault();
  }

  const handleRecordOpen = (record_id) => {
    // alert(record_id);
    setCircularProgressOpen(true);
    // setRefresh(true);
    // setLoading(true)

    const recordDetail = async () => {
      // リフレッシュのための値を初期化
      // setRefresh(false);
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }
  
          const response = await fetch(`${apiHost}${basePath}record/${record_id}/`, {headers});
          setRecordMessage('')
  
          if (response.status === 200) {
            const data = await response.json();

            // レコード表示用html組立

            let recordDetail = ''
            
            // {/* データリスト */}
            recordDetail += '<TableContainer>'
            recordDetail += '  <Table aria-label="simple table">'
            recordDetail += '    <TableHead>'
            recordDetail += '      <TableRow>'
            recordDetail += '        <TableCell>ID</TableCell>'
            recordDetail += '        <TableCell>チェック項目</TableCell>'
            recordDetail += '        <TableCell align="left">チェック</TableCell>'
            recordDetail += '        <TableCell align="left">チェック日時</TableCell>'
            recordDetail += '      </TableRow>'
            recordDetail += '      <br />'
            recordDetail += '    </TableHead>'
            recordDetail += '    <TableBody>'
            
            {data.map((row, index) => {
              recordDetail += '      <TableRow key=' + row.id + '>'
              recordDetail += '        <TableCell component="th" scope="row">' + row.id + '</TableCell>'
              recordDetail += '        <TableCell align="left">' + row.name + '</TableCell>'
              recordDetail += '        <TableCell align="left"><Checkbox checked=' + row.is_checked + ' />' + row.is_checked.toString() + '</TableCell>'
              recordDetail += '        <TableCell align="left">' + row.checked_datetime + '</TableCell>'
              recordDetail += '      </TableRow>'
              recordDetail += '      <br />'
            })}

            recordDetail += '    </TableBody>'
            recordDetail += '  </Table>'
            recordDetail += '</TableContainer>'
                        
            setRecordMessage(recordDetail)
          }
          else if (response.status === 401) {
            setError('ログインしてください');
          }
          else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }

        // setRefresh(true);
        // setLoading(false);

      } catch (err) {
        console.log(err);
      } finally {
        setCircularProgressOpen(false);
        // setRecordMessage('');
        setRecordOpen(true);
      }

  
    // setLogTitle(title);
    // setLogMessage(message);
    }
  recordDetail();
  setRecordId(record_id);
}

  const handleRecordClose = () => {
    setRecordOpen(false);
  }

  const [lists, actionLists, isPendingLists] = useActionState(
    async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(apiHost + basePath, { headers });

        if (response.status === 200) {
          const data = await response.json();
          // setLists(data);
          return data
        }
        else if (response.status === 401) {
          setError('ログインしてください');
        }
        else {
          setError('エラー');
        }
        setRefresh(true);
        setLoading(false);
        } catch (err) {
        console.log(err);
      }
    }, null
  )

  const [updatedPost, submitActionPost, isPendingPost] = useActionState(
    async (previousPost, formData) => {
      const name = formData.get('name');

      const optimistic = {
        uuid: uuid,
        name: name + '（部屋作成中）',
        // room_uuid: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      };

      // 楽観的更新情報を表示
      updateOptimisticPost(optimistic);

      // 入力欄をクリアしてフォーカスを当てる 
      // document.getElementById('name').value = "";
      // document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          const response = await axios.post(`${apiHost}${basePath}`, 
              {
              name: formData.get('name'),
            },
            {headers},
          )

          if (response.status === 201) {
            // setTransactionFinishedDialogOpen(true);
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        // setError('通信エラー');
        return previousPost;
      } finally {
      }
    }, ""
  );

  const [optimisticPost, updateOptimisticPost] = useOptimistic(updatedPost);

  const [updatedGet, actionGet, isPendingGet] = useActionState(
    async () => {
      const optimistic = {
        // room_uuidはonClickイベントでsetIdを渡していて、idに代入済
        uuid: 'loading...',
        name: 'loading...',
        management_cd: 'loading...',
      };

      // 楽観的更新情報を表示
      updateOptimisticGet(optimistic);
      // setName(() => updatedGet.name);


      // 入力欄をクリアしてフォーカスを当てる 
      // document.getElementById('name').value = "";
      // document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          const response = await axios.get(`${apiHost}${basePath}${uuid}/`, 
            {headers},
          )

          if (response.status === 200) {
            setName(response.data.name);
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        setError('通信エラー');
        // return err;
      } finally {
      }
    }, ""
  );

  const [optimisticGet, updateOptimisticGet] = useOptimistic(updatedGet);

  const [updatedPut, submitActionPut, isPendingPut] = useActionState(
    async (previousPut, formData) => {
      const optimistic = {...previousPut,
        // room_uuidはonClickイベントでsetIdを渡していて、idに代入済
        uuid: uuid,
        management_cd: '（更新中）',
        name: name + '（更新中）',
      };

      // 楽観的更新情報を表示
      updateOptimisticPut(optimistic);

      // 入力欄をクリアしてフォーカスを当てる 
      document.getElementById('name').value = "";
      document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          // const response = await axios.put(`${apiHost}${basePath}2983ca11-3e1f-466a-b73b-3451d3695e4b/`, 
          const response = await axios.put(`${apiHost}${basePath}${uuid}/`, 
            {
              // name: formData.get('name'),
              name: name,
            },
            {headers},
          )

          if (response.status === 200) {
            setEditDialogOpen(false);
            // setTransactionFinishedDialogOpen(true);

            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        // setError('通信エラー');
        return previousPut;
      } finally {
      }
    }, ""
  );

  const [optimisticPut, updateOptimisticPut] = useOptimistic(updatedPut);


  useEffect(() => {
    startTransition(async () => actionLists());
    // AutoRef();
  }, [optimisticGet, optimisticPut, updatedGet, updatedPut, ]);


  // // データ更新用
  // useEffect(() => {
  //   fetchchecklists();
  //   fetchrecordchecklists();
  // }, [refresh]);

  const recordPost = async () => {
    setCircularProgressOpen(true);
    // リフレッシュのための値を初期化
    setRefresh(false);

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(`${apiHost}${basePath}record/`, 
          {
            name: 'noname',
          },
          {headers},
        )

        if (response.status === 201) {
          handleAlertOpen(response.data.id, '記録', '記録が完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const fetchchecklists = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

    } catch (err) {
      console.log(err);
    }
  }

  const fetchrecordchecklists = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(`${apiHost}${basePath}recordlists/`, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setRecordChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

  } catch (err) {
      console.log(err);
    }
  }

  const retrieveData = async(pk) => {
    try {
      if (cookies.jwtAccess) {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(`${apiHost}${basePath}${pk}/`, {headers});
        // fetch成功時、status200
        if (response.status === 200) {
          const data = await response.json();

          document.getElementById('name').value = data.name;
          document.getElementById('uuid').value = data.uuid;

          setUuid(pk);
          setName(data.name);
          setUpdateDisabled(false);
          setDeleteDisabled(false);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }

      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const resetData = async() => {
    try {
      document.getElementById('name').value = '';
      setUuid('');
      setName('');

      setUpdateDisabled(true);
      setDeleteDisabled(true);
    } catch (err) {
      console.log(err);
    }
  }

  const createData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        var postData = {
          name: "新規",
          jwt_access: cookies.jwtAccess,
          access_token_username: cookies.accessTokenUsername,
          user: cookies.accessTokenUserId,
        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(apiHost + basePath, postData, {headers});
        // post成功時、status201
        if (response.status === 201) {
          handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const updateData = async (data) => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        startTransition(async () => {
          const response = await axios.put(`${apiHost}${basePath}${uuid}/`, 
            {
              name: name,
            },
            {headers},
          )

          if (response.status === 200) {
            handleAlertOpen(response.data.id, 'データ更新', 'データ更新が完了しました');
            resetData();
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        });
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const deleteData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.delete(`${apiHost}${basePath}${uuid}/`, {headers})
        // delete成功時、status204
        if (response.status === 204) {
          handleAlertOpen(uuid, 'データ削除', 'データ削除が完了しました');
          resetData();
        } else if (response.status === 401){
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
        console.log(err);
    };
  }

  const check = async (pk) => {

    startTransition( async () => {
      // 楽観的な更新を適用
      addOptimisticData({
        name: '更新中',
        is_checked: false,
        checked_datetime: pk,
      });  
    })

    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.put(`${apiHost}${basePath}check/${pk}/`, 
          {
            // name: dataName,
          },
          {headers},
        )

        if (response.status === 200) {
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const reload = () => {
    window.location.reload();
  }

  // if(loading) return <p>Loading...</p>;
  // if(error) return <><p className="errMsg">Error: {error ? error : error.message}<a href="">[再読込]</a></p><StyledButton onClick={reload}>再読込</StyledButton></>;

  // const rows = Array.from({ length: 200}, (_, index) => createData(index));

  return (
    <>
      <div><StyledButton onClick={recordPost}>完了</StyledButton></div>
 
      {!isPendingLists && <><LinearProgress variant="determinate" value={"100"} /></>}
      {isPendingLists && <><LinearProgress /></>}
 
      <div>
        {Array.isArray(recordChecklists)
          ? recordChecklists.map((recordChecklist, index) => {
            // const parseJSON = JSON.parse(logChecklist.logchecklist);
            // console.log(parseJSON)
            return (
              <p>
                <StyledButtonLogLists onClick={() => {handleRecordOpen(recordChecklist.id)}}>
                【{recordChecklist.id}】
                {format(recordChecklist.created_at, "yyyy-MM-dd HH:mm:ss")}
                </StyledButtonLogLists>
              </p>
            )
          })
          : null
        }
      </div>

      {/* データリスト */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>,
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>名前</TableCell>
              <TableCell>チェック項目</TableCell>
              <TableCell align="left">チェック（switch）</TableCell>
              <TableCell align="left">チェック（checkbox）</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(lists)
            ? lists.map((list, index) => (
              <TableRow key={list.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">{list.uuid}</TableCell>
                {/* <TableCell align="left"><Chip label={list.name} color="primary" onClick={() => {retrieveData(list.uuid)}} /></TableCell> */}
                {/* <TableCell align="left"><Chip label={list.name} color="primary" onClick={() => {setEditDialogOpen(true); alert(list.uuid)}} /></TableCell> */}
                <TableCell align="left"><Chip label={list.name} color="primary" onClick={() => {setUuid(list.uuid); setEditDialogOpen(true); startTransition(async () => actionGet())}} /></TableCell>
                <TableCell align="left"><Switch checked={list.is_active} onClick={() => {check(list.uuid)}} />{list.is_active.toString()}</TableCell>
                <TableCell align="left"><Checkbox checked={list.is_active} onClick={() => {check(list.uuid)}} />{list.is_active.toString()}</TableCell>
              </TableRow>
            ))
            : null
          }
          </TableBody>
        </Table>
      </TableContainer>

      <div className="container">
        <form action={submitActionPost}>
          <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" />

          {/* ボタン押下の処理中かそうでないかにより、表示内容を変更 */}
          <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} disabled={isPendingPost}>
            {!isPendingPost && <>部屋を作成</>}
            {isPendingPost && <>処理中...</>}
          </AppButton>
          {optimisticPost.name}

          {/* 処理中の場合、表示 */}
          {isPendingPost && <>
            <CircularProgress variant="indeterminate"
              disableShrink
              enableTrackSlot
              sx={(theme) => ({
                color: '#e42e16',
                animationDuration: '1000ms',
                ...theme.applyStyles('dark', {
                  color: '#308fe8',
                }),
              })}
              size={40}
              thickness={4}
            />
          </>}
        </form>
      </div>

      {/* <div><StyledButton onClick={createData}>データ追加</StyledButton></div> */}

        {/* データリスト */}
        {/* {Array.isArray(checklists)
          ? checklists.map((checklist, index) => {
            return <AppButton key={index} onClick={() => {retrieveData(checklist.id)}}>【{checklist.id}】{checklist.name}</AppButton>
          })
          : null
        } */}

      <div className="bd-callout bd-callout-warning">
        {/* <form>
          <Chip label= {` ID : ${uuid} `} id="uuid" variant="outlined" />
          <label htmlFor="name" style={{margin:"0.5rem", padding:"0.5rem"}}>名前</label>
          <input id="name" type="text" disabled={updateDisabled} {
            ...register('name',
              {
                onChange: (e) => setName(e.target.value)
              }
            )} />
          <p className="ErrMsg">{errors.name?.message}</p>
        </form> */}

      <div><AppButton key={uuid} disabled={updateDisabled} onClick={() => {updateData()}}>更新</AppButton></div>
      <div><AppButton key={uuid} disabled={deleteDisabled} onClick={() => {deleteData()}}>削除</AppButton></div>

      {/* DataGrid */}
      <Box
        sx={{
          // height: 500,
          // width: '100%',
          [`.${gridClasses.cell}.checked`]: {
            backgroundColor: '#b9d5ff91',
            color: '#1a3e72',
          },
          [`.${gridClasses.cell}.unchecked`]: {
            backgroundColor: '#ff943975',
            color: '#1a3e72',
          },
        }}
        >
        <DataGrid
          getRowId={(row) => row.uuid}
          autosizeOnMount
          autosizeOptions={{
            // Autosizingに使用するカラム
            // columns: ['id', 'name', 'is_checked', 'checked_datetime'],
            columns: ['uuid', 'name', 'is_active'],
            // Header部分及びdata部分のそれぞれの文字列の長さにより、幅を自動調整するかどうかの設定
            includeHeaders: true,
            includeOutliers: true,
          }}
          sx={{
            m: 2,
            boxShadow: 2,
            border: 2,
          }}
          rows={checklists}
          columns={columns}
          getCellClassName={(params) => {
            // if (params.field === 'is_checked' && params.value === true) {
            //   return 'checked';
            // } else if (params.field === 'is_checked' && params.value === false) {
            //   return 'unchecked';
            // } else {
            //   return '';
            // }
            if (params.field === 'is_active' && params.value === true) {
              return 'checked';
            } else if (params.field === 'is_active' && params.value === false) {
              return 'unchecked';
            } else {
              return '';
            }
          }}
        />
      </Box>

      <Dialog open={editDialogOpen}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="edit-dialog-title">
          【編集】
          {(!isPendingGet && !isPendingPut) && <><LinearProgress variant="determinate" value={"100"} /></>}
          {(isPendingGet || isPendingPut) && <><LinearProgress /></>}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText style={{display: 'flex', alignItems: 'flex-start', }}>
            <form action={submitActionPut}>
              uuid:{uuid}
              <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" value={name} onChange={(e) => setName(e.target.value)} />
              {/* <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" value={updatedGet.name} onChange={(e) => setName(e.target.value)} /> */}
              <AppButton type="submit" disabled={(isPendingGet || isPendingPut)} style={{ margin: "5px", fontSize: 20, }} onClick={() => {setUuid(uuid);}}>
                {(!isPendingGet && !isPendingPut) && <>更新</>}
                {isPendingGet && <>読込中</>}
                {isPendingPut && <>更新中</>}
              </AppButton>
              <AppButton disabled={isPendingPut} onClick={handleEditDialogClose} style={{ margin: "5px", fontSize: 20, }}>キャンセル</AppButton>
            </form>
            </DialogContentText>
        </DialogContent>
      </Dialog>

        <Dialog
          open={circularProgressOpen}
          aria-labelledby="circular-progress-dialog-title"
          aria-describedby="circular-progress-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="circular-progress-dialog-title">
            Loading...
          </DialogTitle>
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>

        <Dialog
          open={alertOpen}
          onClose={handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            【{alertId}】{alertTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <AppButton onClick={handleAlertClose} autoFocus>OK</AppButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={recordOpen}
          onClose={handleRecordClose}
          aria-labelledby="record-dialog-title"
          aria-describedby="record-dialog-description"
        >
          <DialogTitle id="record-dialog-title">
            【{recordId}】{recordTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="record-dialog-description" dangerouslySetInnerHTML={{ __html: recordMessage}} />
          </DialogContent>
          <DialogActions>
            <AppButton onClick={handleRecordClose} autoFocus>OK</AppButton>
          </DialogActions>
        </Dialog>

      </div>

      {/* <div>
        {Array.isArray(logChecklists)
          ? logChecklists.map((logChecklist, index) => {
            return <AppButton key={index} onClick={() => {retrieveData(logChecklist.id)}}>【{logChecklist.id}】{logChecklist.logchecklist}</AppButton>
          })
          : null
        }
      </div> */}

      {/* <div>
        {Array.isArray(logChecklists)
          ? logChecklists.map((logChecklist, index) => {
            return (
              <p>
                {JSON.parse(logChecklist.id)}
                {logChecklist.logchecklist}
              <br /><br /></p>
            )
          })
          : null
        }
      </div> */}
    </>
  )
}
export default Checklist2
